<template>
  <router-view />
</template>

<script>
export default {
  name: "app-labelorder"
};
</script>

<style lang="scss" scoped></style>
